import { IsSearchField } from "../core/components/isSearchField";
import { IsPanelbarDetails } from "../core/components/isPanelbarDetails";
import { MetaDataHelper } from "../core/util/metaDataHelper";
import React from "react";
export default class UserSettingsSelectUser extends React.Component<any, any> {
    createIsSearchField() {
        var field = {
            type: "is-search-field",
            model: "entity.User.Name",
            name: "Ressource.Ressource",
            listWidth: 450,
            autocompleteEnabled: true,
            autocompleteTemplate: "<table cellspacing='0' style='table-layout:fixed; width:350px'><colgroup><col style='width: 150px' /><col style='width: 150px' /></colgroup><tr><td style='vertical-align:top; word-wrap: break-word;'>${data.Name}</td><td style='vertical-align:top'>${data.Name2}</td></tr></table>",
            autocompleteUrl: "UserLookup/Find",
            autocompleteDataTextField: "Name",
            searchButtonEnabled: true,
            searchWindowTitle: this.props.translations["Standard.Benutzersuche"],
            searchWindowUrl: "DynamicSearch/Window/User",
            readOnlyTextField: true
        }
        return field;
    }

    createIsPanelBarDetails() {
        var field = {
            type: "is-panelbar-details",
            model: "entity.User.Name",
            url: "UserLookup/UserHeader",
            template: "UserDetails"
        }
        return field;
    }

    render() {
        if (this.props.entity.RecordRight.UserConfiguration) {
            let value = MetaDataHelper.getFieldValue(this.props.entity, "entity.User.Name")

            return (
                <div style={{ width: "400px", margin: "5px", display: "flex", flexWrap: "wrap" }}>
                    <label style={{ marginTop: "10px", marginRight: "15px" }}>{this.props.translations["Server.User"]}</label>
                    <div style={{ flex: "1" }}>
                        <IsSearchField field={this.createIsSearchField()} value={value} context={this.props.context} commandManager={null}
                            onChange={this.props.handleFieldChange} handleEval={this.props.handleEval} handleIsSearchFieldFullObjectModel={this.props.handleIsSearchFieldFullObjectModel}
                            multiSelectMode={false} disabled={false} />
                        <div style={{ marginTop: "7px" }} >
                            <IsPanelbarDetails field={this.createIsPanelBarDetails()} value={value} context={this.props.context} onDataLoaded={this.props.handleDataLoaded} commandManager={this.props.commandManager} />
                        </div>
                    </div>
                </div>
            );
        }
        else {
            return null;
        }
    }
};